import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Response } from '../../../shared/models/response.model';

import { Ressource } from '../models/ressource.model';
import { RessourceCreateRequest } from '../requests/ressource-create-request.model';
import { RessourceUpdateRequest } from '../requests/ressource-update-request.model';

export const RessourceTypeNames = ['Connaissance', 'Documentation', 'Matériel', 'Habileté'] as const;
export type RessourceTypeName = (typeof RessourceTypeNames)[number];

@Injectable({
  providedIn: 'root',
})
export class RessourceService {
  #http = inject(HttpClient);

  readonly BASE_URL = `/ressources`;

  findById = (id: string) => this.#http.get<Ressource>(this.BASE_URL + '/' + id);

  findAll(idCartographie: string) {
    let params = new HttpParams().append('idCartographie', idCartographie);

    return this.#http.get<Response<Ressource>>(this.BASE_URL, { params: params });
  }
  create = (idCartographie: string, data: RessourceCreateRequest) =>
    this.#http.post<void>(this.BASE_URL, data, { params: { idCartographie } });

  edit = (id: string, data: RessourceUpdateRequest) => this.#http.put<void>(this.BASE_URL + '/' + id, data);

  delete = (id: string) => this.#http.delete(this.BASE_URL + '/' + id);
}
